<mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
  <!-- feuille -->
  <mat-tree-node *matTreeNodeDef="let node"
                 matTreeNodeToggle
                 matTreeNodePadding
                [ngClass]="editMode ? 'tree-drag': 'tree-pointer'">
    <ng-container *ngIf="editMode">
      <button mat-icon-button disabled></button>
      <span class="checklist-leaf-node"
                    [ngClass]="{'drop-above': dragNodeExpandOverArea === 'above' && dragNodeExpandOverNode === node,
                                'drop-below': dragNodeExpandOverArea === 'below' && dragNodeExpandOverNode === node,
                                'drop-center': dragNodeExpandOverArea === 'center' && dragNodeExpandOverNode === node}"
                    (change)="checklistSelection.toggle(node);"
                    [draggable]="true"
                    (dragstart)="handleDragStart($event, node);"
                    (dragover)="handleDragOver($event, node);"
                    (drop)="handleDrop($event, node);"
                    (dragend)="handleDragEnd($event);">{{node?.item?.data?.title}}</span>
      <button mat-icon-button (click)="editNode(node.item)"><mat-icon>edit</mat-icon></button>
      <button mat-icon-button (click)="deleteNode(node)"><mat-icon>delete</mat-icon></button>
    </ng-container>
    <ng-container *ngIf="! editMode">
      <span class="leaf-node-pointer"
            [ngClass]="selectedNode === node ? 'leaf-strong' : ''"
            (click)="onClickLevel($event, node)"
            draggable="false">{{node?.item?.data?.title}}</span>
    </ng-container>
  </mat-tree-node>
  <!-- catégorie -->
  <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
                 matTreeNodePadding
                 [ngClass]="editMode ? 'tree-drag': 'tree-pointer'">
    <button mat-icon-button matTreeNodeToggle
            [attr.aria-label]="'toggle ' + node.filename">
      <mat-icon class="mat-icon-rtl-mirror">
        {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
      </mat-icon>
    </button>
    <ng-container *ngIf="editMode">
      <span [ngClass]="{'drop-above': dragNodeExpandOverArea === 'above' && dragNodeExpandOverNode === node,
                                'drop-below': dragNodeExpandOverArea === 'below' && dragNodeExpandOverNode === node,
                                'drop-center': dragNodeExpandOverArea === 'center' && dragNodeExpandOverNode === node}"
                    draggable="true"
                    (dragstart)="handleDragStart($event, node);"
                    (dragover)="handleDragOver($event, node);"
                    (drop)="handleDrop($event, node);"
                    (dragend)="handleDragEnd($event);"
                    (change)="todoItemSelectionToggle(node)">{{node?.item?.data?.title}}</span>
      <button mat-icon-button (click)="editNode(node.item)"><mat-icon>edit</mat-icon></button>
    </ng-container>
    <ng-container *ngIf="! editMode">
      <span draggable="false"
            (click)="onClickLevel($event, node)"
            (change)="todoItemSelectionToggle(node)">{{node?.item?.data?.title}}</span>
    </ng-container>
  </mat-tree-node>
</mat-tree>

<span #emptyItem></span>
